export default "__VITE_ASSET__cfdccd83__"